import { render, staticRenderFns } from "./CreateApplicantModalComponent.vue?vue&type=template&id=a6a04460&"
import script from "./CreateApplicantModalComponent.vue?vue&type=script&lang=ts&"
export * from "./CreateApplicantModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a04460')) {
      api.createRecord('a6a04460', component.options)
    } else {
      api.reload('a6a04460', component.options)
    }
    module.hot.accept("./CreateApplicantModalComponent.vue?vue&type=template&id=a6a04460&", function () {
      api.rerender('a6a04460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/Applicant/CreateApplicantModalComponent.vue"
export default component.exports